import { Controller } from '@hotwired/stimulus';

const DURATION = 220;
const EASING = 'ease-out';

// Connects to data-controller="faq"
//
// Native <details> height:auto has no smooth animation path (the
// interpolate-size/::details-content approach only approximates it, and
// visibly janks). This measures real pixel heights via WAAPI instead, and
// closes sibling items before opening one (exclusive accordion).
export default class extends Controller {
  static targets = ['item'];

  connect() {
    this.itemTargets.forEach((item) => {
      const summary = item.querySelector('summary');
      summary.addEventListener('click', (e) => this.handleClick(e, item));
    });
  }

  handleClick(event, item) {
    event.preventDefault();
    if (item.classList.contains('animating')) return;

    if (item.open) {
      this.shrink(item);
    } else {
      this.itemTargets.forEach((other) => {
        if (other !== item && other.open && !other.classList.contains('animating')) {
          this.shrink(other);
        }
      });
      this.expand(item);
    }
  }

  shrink(item) {
    item.classList.add('animating');
    const startHeight = `${item.offsetHeight}px`;
    const endHeight = `${item.querySelector('summary').offsetHeight}px`;

    const animation = item.animate(
      { height: [startHeight, endHeight] },
      { duration: DURATION, easing: EASING },
    );
    animation.onfinish = () => this.finish(item, false);
  }

  expand(item) {
    item.classList.add('animating');
    const startHeight = `${item.offsetHeight}px`;
    item.open = true;

    requestAnimationFrame(() => {
      const endHeight = `${item.scrollHeight}px`;
      const animation = item.animate(
        { height: [startHeight, endHeight] },
        { duration: DURATION, easing: EASING },
      );
      animation.onfinish = () => this.finish(item, true);
    });
  }

  finish(item, open) {
    item.open = open;
    item.style.height = '';
    item.classList.remove('animating');
  }
}
